import { useEffect } from 'react';
import { toast } from 'sonner';
import { playNotificationSound } from '../utils/notification-sound';

export function GlobalNotificationHandler() {
  useEffect(() => {
    const handleNotification = (event: CustomEvent<{
      message: any;
      conversationId: string;
      senderName: string;
      preview: string;
    }>) => {
      const { conversationId, senderName, preview } = event.detail;

      playNotificationSound();

      toast(senderName || 'New message', {
        description: preview.length > 80 ? preview.slice(0, 77) + '…' : preview,
        duration: 5000,
        action: {
          label: 'View',
          onClick: () => {
            window.dispatchEvent(
              new CustomEvent('navigate-to-conversation', {
                detail: { conversationId },
              })
            );
          },
        },
      });
    };

    window.addEventListener('ws-notification' as any, handleNotification);
    return () =>
      window.removeEventListener('ws-notification' as any, handleNotification);
  }, []);

  return null;
}